import client from './client';

/* eslint-disable import/prefer-default-export, @typescript-eslint/explicit-module-boundary-types */
export const fetch = () => client.request({
  method: 'GET',
  url: '/constants',
});
/* eslint-enable import/prefer-default-export, @typescript-eslint/explicit-module-boundary-types */
